import React from "react";
import { Link } from "react-router-dom";

import Avatar from "components/Avatar/Avatar";
import Heading from "components/Elements/Heading";

import clsx from "clsx";

const User = ({ user }) => {
  const firstName = user.firstName || user.item?.firstName;
  const lastName = user.lastName || user.item?.lastName;
  const email = user.email || user.item.email;

  let initials = null;

  if (firstName && lastName) {
    initials = firstName.charAt(0) + lastName.charAt(0);
  } else if (firstName) {
    initials = firstName.charAt(0);
  } else if (lastName) {
    initials = lastName.charAt(0);
  } else {
    initials = "•";
  }

  const edit_button_styles = clsx("mt-auto", "user__edit");

  return (
    <section className="user">
      <Avatar initials={initials} />

      <Heading size={6} className={"mb-1 text-center"}>
        <b className="text-break">
          {firstName} {lastName}
        </b>
      </Heading>

      <Heading size={6} className={"mb-1 text-center"}>
        <small className="user__email">{email}</small>
      </Heading>

      <Link to={`/settings/user/${email}`} className={edit_button_styles}>
        Edit User
      </Link>
    </section>
  );
};

export default User;
